const getUser = state => state.user; // prettier-ignore
const isLogged = state => state.user && state.user.email; // prettier-ignore

export default {
  getUser,
  isLogged,
};
